import React from "react";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { LiLink } from "../../../common/commonComps";
import Ad from "../../account/components/ad";
import type { AppContext, Size } from "../../../types";

interface CBRCustomSmallCarouselProps {
    context: AppContext;
    size: Size;
    viewportWidth: number;
}

const CBRCustomSmallCarousel = (cx: CBRCustomSmallCarouselProps): React.ReactElement | null => {
    const { context, size, viewportWidth } = cx;

    const [show, setShow] = useState<boolean>(true);

    useEffect(() => {
        if (viewportWidth < 1050) {
            if (show) {
                setShow(false);
            }
        } else if (!show) {
            setShow(true);
        }
    }, [viewportWidth]);

    if (context.liBxInstalledData || !context?.adminConfig?.mall?.ad_placements?.mall_placement) {
        return null;
    }

    return (
        <Box
            sx={{
                display: show ? `flex` : `none`,
                alignItems: `center`,
                justifyContent: `center`,
                width: size === `small` ? `unset` : 324,
                padding: `0 0 0 12px`,
            }}
        >
            <LiLink
                sx={{ padding: 0 }}
                py={0}
                to={context?.adminConfig?.mall?.ad_placements?.mall_placement.url || `#`}
            >
                <Ad
                    size={size}
                    sx={{ borderRadius: `0 10px 10px 0` }}
                    visual={context?.adminConfig?.mall?.ad_placements?.mall_placement.visual}
                />
            </LiLink>
        </Box>
    );
};
export default CBRCustomSmallCarousel;
